__turbopack_context__.v({
  "container": "AnalysisInsights-module__sj8Sya__container",
  "headerInfo": "AnalysisInsights-module__sj8Sya__headerInfo",
  "iconWrapper": "AnalysisInsights-module__sj8Sya__iconWrapper",
  "insightsList": "AnalysisInsights-module__sj8Sya__insightsList",
  "paginationWrapper": "AnalysisInsights-module__sj8Sya__paginationWrapper",
  "subtitle": "AnalysisInsights-module__sj8Sya__subtitle",
  "texts": "AnalysisInsights-module__sj8Sya__texts",
});
